<section class="col-12 d-flex justify-content-center">
  <plyca-ui-panel [config]="{ headerPanel: 'Properties' }" class="panel-demo">
    <div class="panel-demo properties">
      <span>{{ 'Name' }}</span>
      <p>{{ 'Example' }}</p>
      <span>{{ 'Description' }}</span>
      <p>{{ 'Example' }}</p>
    </div>
  </plyca-ui-panel>
</section>
